






























import { Component, Prop, Vue,Emit,Watch,Mixins} from 'vue-property-decorator'
import { ClassData, EventData,EventExtendedProps, NoticeProps } from "@/scripts/datatypes"

import Common from '@/mixins/common'
import moment from 'moment-timezone'
import firestore from 'firebase'

@Component

export default class ModalEventHistory extends Mixins(Common) {
  @Prop({type: String, default: ''}) private message?: string
  @Prop({type: String, default: 'message.yes'}) private confirmText?: string
  @Prop({type: String, default: 'message.no'}) private cancelText?: string
  @Prop({type: String, default: ''}) private errorMessage?: string

  @Prop({type: Object, default: {}}) private theEventData?: EventData

  isActive = true

  title = ''


  dateTime = ''

  changelogs = {} 

  exProps = {} as EventExtendedProps

/*
  get span(){
    const start = moment(this.startDateTime || '');
    const end   = moment(this.endDateTime || '');
    if(start.isValid() && end.isValid()){
      return Math.round((end.diff(start,'minutes') / 60) * 10) / 10
    }
    return 0
  }
*/

  
  async created(){
    try{
    if(this.theEventData){
      this.exProps = this.theEventData.extendedProps
      this.title = this.theEventData.title || ''
      moment.tz.setDefault(this.theEventData.timeZone);
      // start と end で日付が違うかどうか
      const start = moment(this.theEventData.start)
      const end = moment(this.theEventData.end)
      const isSameday = moment(this.theEventData.start).startOf('day').diff(moment(this.theEventData.end).startOf('day')) === 0 ? true : false

      this.dateTime = start.format('LLLL') + ' – '
      if(isSameday){
        this.dateTime += end.format('LT')
      }else{
        this.dateTime += end.format('LLLL')
      }

      const theEventChangelogsRef = this.$getEventChangelogsColRef(this.theEventData.id).orderBy('creationTime','desc')

      const theEventChangelogsData = await theEventChangelogsRef.get()

      const theEvent = (await this.$getEventDocRef(this.theEventData.id).get()).data() as firebase.default.firestore.DocumentData

      const theEventChangelogs = theEventChangelogsData.docs.map((doc , index) => {
        const row = doc.data()
        for(const key in row){
          if(row[key].nanoseconds){
            row[key] = row[key].toDate().getTime()
          }
        }
        return row
      })

      theEventChangelogs.push(theEvent)
      

      this.changelogs = theEventChangelogs.map((log,index) => {
        const log1 = theEventChangelogs[index]
        const log2 = theEventChangelogs[index + 1] ? theEventChangelogs[index + 1] : {}

        return this.diff(log1,log2)
      })
    }

    }catch(error){
      console.log(error)
    }
  }
  
  

  diff(obj1: any, obj2: any) {
    const result = {} as any

    Object.keys(obj1).forEach((key) => {
      let val1 = obj1[key]

      if(typeof obj1[key] === 'object'){
        val1 = JSON.stringify(Object.keys(obj1[key]).sort())
      }else if(typeof obj1[key] as any === 'array'){
        val1 = JSON.stringify(obj1[key].sort())
      }

      let val2 = obj2[key]

      if(typeof obj2[key] === 'object'){
        val2 = JSON.stringify(Object.keys(obj2[key]).sort())
      }else if(typeof obj2[key] as any === 'array'){
        val2 = JSON.stringify(obj2[key].sort())
      }

      if(val1 !== val2){
        result[key] = obj1[key]
      }
    })

    if(Object.keys(result).length === 1 && result.creationTime){
      return {}
    }

    return result;
  }

  mounted(){    
    //
  }

  onConfirm(yes: boolean) {
    this.$emit("onConfirm", yes);
  }
}
